/* eslint-disable no-mixed-spaces-and-tabs */
import { React } from 'react';
import { SettingsView } from '@/components/views/SettingsView';

export const SettingsPage = () => {
	return <SettingsView />;
};
